const themeProperties = {
  defaultFontFamily:
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  fontSizes: {
    fontXXXXSmallNew: '6px',
    fontXXXSmallNew: '8px',
    fontXXSmall: '10px',
    fontXSmall: '12px',
    fontSmall: '14px',
    fontSixteen: '16px',
    fontMedium: '18px',
    fontLarge: '22px',
    fontXLarge: '26px',
    fontXXLarge: '36px',
    fontXXXLarge: '48px',
    //to be converted to same unit
    fontRemLarge: '2.25rem',
    fontRemMedium: '1.5rem',
    fontRemSmall: '1.125rem',
    fontRemXSmall: '0.875rem',
  },
  primaryColor: '#68B030',
  primaryDarkColor: '#007a49',
  primaryLightColor: '#79AE4633',
  greenHazeColor: '#2196530d',
  lightBlueColor: '#48AADD',
  darkBlackColor: '#4F4F4F',
  darkOliveGreen: '#688816',
  topProjectBackgroundColor: '#F3BB44',
  ceruleanBlueColor: '#2d9cdb0d',
  mintGreenColor: '#6fcf97',
  mediumGrayColor: '#828282',
  lightGrayColor: '#f2f2f2',
  amethystPurpleColor: '#9b51e00d',
  lavenderPurpleColor: '#c98eff',
  skyBlueColor: '#87ceeb',
  mediumBlueColor: '#2d9cdb',
  electricPurpleColor: '#9b51e0',
  nonDonatableProjectBackgroundColor: '#828282',
  deforestrationRangeBackgroundNew: '235, 87, 87',
  primaryColorNew: '#219653',
  horizontalLineColorNew: '#bdbdbd',
  restorationToggleColorNew: '#2f80ed',
  deforestrationToggleColorNew: 'rgba(235, 87, 87, 1)',
  exploreDescriptionBackground: '242, 242, 242',
  light: {
    primaryFontColor: '#2f3336',
    dividerColor: '#d5d5d5',
    secondaryColor: '#ecb641',
    highlightBackground: '#4d5153',
    backgroundColor: '#fff',
    light: '#fff',
    dark: '#000',
    dangerColor: '#e74c3c',
    safeColor: '#2980b9',
    backgroundColorDark: '#F2F2F7',
    unDecadeFill: '#1d1d1b',
    mapboxIcon: 'invert(0) hue-rotate(180deg)',
    backgroundBase: '#F0F6F5',
    disabledFontColor: '#909090',
    tabBackgroundColor: '#f4ffec',
    grayFontColorNew: '#4F4F4F',
    lightGrayBackgroundColorNew: '#d9d9d980',
    boldFontColorNew: '#2F3336',
    selectedMenuItemColorNew: '#333',
    dividerColorNew: '#BDBDBD',
    reviewFontColorNew: '45, 156, 219', //used across elements with different opacities, this enables consistency throughout
    aboutProjectBackgroundColorNew: '#27ae601a',
    dangerColorNew: '#E86F56',
    abandonmentBackgroundColorNew: '242, 201, 76',
    moreInfoBackgroundColorNew: '81, 198, 205',
    certificationBackgroundColorNew: '108, 99, 255',
    contactDetailBackgroundColorNew: '232, 111, 86',
    certificationLinkColorNew: '#3AB6BD',
    secondaryDividerColor: '242, 153, 74',
    borderColor: '211, 211, 211',
  },
  dark: {
    primaryFontColor: '#ffffff',
    dividerColor: '#101113',
    secondaryColor: '#ecb641',
    backgroundColor: '#343a40',
    highlightBackground: '#f2f2f2',
    light: '#fff',
    dark: '#000',
    darkNew: '#333333',
    dangerColor: '#00ef00',
    safeColor: '#2980b9',
    backgroundColorDark: '#101113',
    unDecadeFill: '#fff',
    mapboxIcon: 'invert(0.8) hue-rotate(180deg)',
    backgroundBase: '#202020',
    disabledFontColor: '#686868',
  },
  fontWeight: '700',
};

export default themeProperties;
